import { CarePathIcon, CollectionLink } from '@ksyos/design-system';
import { Link as ReactRouterLink, useLocation } from '@ksyos/router';
import type { EpisodeCategory } from '../../../../../common/enums';
import { episodeCategoryIconName } from '../../../elements/Icons/episodeCategoryIconName';

interface IGroupActiveCarePathDetailsCollectionLinkItemProps {
    episodeCategory: EpisodeCategory;
    isActive: boolean;
    subtitle: string;
    title: string;
}

export function GroupCarePathDetailsCollectionLinkItem(props: IGroupActiveCarePathDetailsCollectionLinkItemProps) {
    const { pathname } = useLocation();

    return (
        <CollectionLink
            as={ReactRouterLink}
            mediaItem={
                <CarePathIcon
                    icon={episodeCategoryIconName(props.episodeCategory)}
                    size={48}
                    variant="large-multicolor"
                />
            }
            subtitle={props.subtitle}
            title={props.title}
            to={getNavigationPreferenceLink(props.episodeCategory)}
        />
    );

    function getNavigationPreferenceLink(episodeCategory: EpisodeCategory) {
        if (props.isActive) {
            return `${pathname}/carePaths/${episodeCategory}`;
        }

        return `${pathname}/inactiveCarePaths/${episodeCategory}`;
    }
}
